<template>
  <div class="">
      <!-- Credit Card Settings ... helps signup with Stripe -->

      <br />
      <v-card>

        <v-card-title primary-title>
          Buyers can choose to get items: &nbsp; <b>{{ deliveryOptionsEnabled }}</b>
        </v-card-title>
        <v-card-text v-if="rateString">{{ rateString }}</v-card-text>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show; updateSuccess = false" flat color="accent">
            Change Options
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>

         </v-btn>

        </v-card-actions>

        <v-slide-y-transition>
          <v-card-text v-show="show" >
            <v-layout>
              <v-flex>
                In person delivery allows buyers you know to have you deliver the
                item to them in person (usually at school or if you see them frequently).
              </v-flex>
              <div>
                <v-switch readonly :loading="inprogressInPerson" v-on:click="setInPersonDelivery($event)" v-model="inpersonDelivery"></v-switch>
              </div>
            </v-layout>

            <v-layout>
              <v-flex>
                The mail option allows buyers to request you ship the item to them. This
                will add on a shipping charge you can set also.
              </v-flex>
              <div>
                <v-switch readonly :loading="inprogressMail"  v-model="mailDelivery" v-on:click="setMailDelivery()"></v-switch>
              </div>
            </v-layout>

            <v-layout v-if="mailDelivery" column>
              <v-flex>
                <v-radio-group v-model="shippingRadioGroup" >
                  <div slot="label">Shipping options</div>
                  <v-radio value="free" :class="{ 'yellow lighten': shippingRadioGroup==='free' }">
                      <div slot="label"><strong>Free delivery:</strong> no shipping charge will be added.</div>
                  </v-radio>
                  <v-radio value="flat" :class="{ 'yellow lighten': shippingRadioGroup==='flat' }">
                      <div slot="label">
                        <strong>Flat rate:</strong> a single shipping charge will be added to each shipped order no matter how large the order is.
                        <div v-if="shippingRadioGroup=='flat'">
                            Charge amount:
                            <VCurrencyField
                              v-model.number="shippingRateToSet"
                              class="d-inline-flex"
                            ></VCurrencyField>
                        </div>
                      </div>
                  </v-radio>
                  <v-radio value="flatperitem" :class="{ 'yellow lighten': shippingRadioGroup==='flatperitem' }">
                      <div slot="label">
                        <strong>Flat rate per Item:</strong> a shipping charge will be added for each item being shipped.
                        <div v-if="shippingRadioGroup=='flatperitem'">
                            Charge amount:
                            <VCurrencyField
                              v-model.number="shippingRateToSet"
                              class="d-inline-flex"
                            ></VCurrencyField>
                        </div>
                      </div>
                  </v-radio>
                  <v-radio value="computed" :class="{ 'yellow lighten': shippingRadioGroup==='computed' }">
                      <div slot="label"><strong>USPS computed:</strong> An estimated USPS rate will be computed based on product length/width/height/weight. This requires you to set dimensions and weight for each item being sold.</div>
                  </v-radio>
                </v-radio-group>

                <v-layout row align-center justify-center>
                  <v-btn class="primary" @click="saveChanges">Save Changes</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout row class="heading success--text " v-show="updateSuccess">
              <v-spacer></v-spacer>
              Delivery options updated successfully.
              <v-spacer></v-spacer>
            </v-layout>

            <v-layout row class="heading error--text " v-show="errMessage">
              <v-spacer></v-spacer>
              {{errMessage}}
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
import firebase from 'firebase/app'
import VCurrencyField from '../VCurrencyField'
import utils from '../../../utils.ts'

export default {
  name: 'DeliverySettings',
  components: {
    VCurrencyField
  },
  computed: {
    ...mapState({
      uid: state => state.admin.uid,
      mailDelivery: state => state.admin.public_settings.acceptMailDelivery,
      inpersonDelivery: state => state.admin.public_settings.acceptInPersonDelivery,
      shippingType: state => state.admin.public_settings.shippingType || state.settings.defaults.shippingType, // Free, flat, flatperitme, computed
      shippingRate: state => state.admin.public_settings.shippingRate || state.settings.defaults.shippingRate, // Cost associated with shipping type,
      locked: state => state.admin.public_settings.locked
    }),
    deliveryOptionsEnabled () {
      let str = ''
      let comma = '' // We may need a comma
      if (this.inpersonDelivery) {
        str += 'in person'
        comma = ', '
      }

      if (this.mailDelivery) {
        str += comma + 'by mail'
      }

      return str
    },
    rateString () {
      if (this.mailDelivery) {
        if (this.shippingType === 'free') {
          return 'Free shipping will be offered.'
        } else if (this.shippingType === 'flat') {
          return `Flat rate shipping of $ ${utils.formatCurrency(this.shippingRate)} will be added to each shipped order.`
        } else if (this.shippingType === 'flatperitem') {
          return `A shipping charge of $ ${utils.formatCurrency(this.shippingRate)} will be for each item ordered.`
        } else if (this.shippingType === 'computed') {
          return `An estimated USPS shipping charge will be computed using product dimensions and weight.`
        } else {
          return 'Unknown shipping type!'
        }
      }
      return ''
    }
  },
  watch: {
    'show': function () {
      this.setCurrentValues()
    }
  },
  data () {
    return {
      show: false,
      inprogressMail: false,
      inprogressInPerson: false,
      updateSuccess: false,
      errMessage: null,
      shippingRadioGroup: false,
      shippingRateToSet: 0
    }
  },
  methods: {

    setCurrentValues: function () {
      // Set the current values we have
      this.shippingRadioGroup = this.shippingType
      this.shippingRateToSet = this.shippingRate
    },
    saveChanges: async function () {
      this.inprogressShipping = true
      this.errMessage = ''
      this.updateSuccess = false

      console.log('Setting shipping type to : ' + this.shippingRadioGroup)
      console.log('Setting shipping amt to : ' + this.shippingRateToSet)
      if (this.locked) {
        this.errMessage = 'Account is locked. You cannot make any changes.'
        return
      }

      if (!this.shippingRadioGroup) {
        this.errMessage = 'You must select a shipping option'
        return
      }

      if (this.shippingRadioGroup === 'flat' || this.shippingRadioGroup === 'flatperitem') {
        if (!this.shippingRateToSet || this.shippingRateToSet < 0) {
          this.errMessage = 'The shipping charge amount to add must be set.'
          return
        }
      }
      if (this.shippingRadioGroup === 'free' || this.shippingRadioGroup === 'computed' ) {
        this.shippingRateToSet = 0
      }
      try {
        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'shippingType': this.shippingRadioGroup,
            'shippingRate': this.shippingRateToSet
          }, {merge: true})
         this.updateSuccess = true
      } catch (err) {
        this.errMessage = err
      }
      this.inprogressShipping = false
    },
    setMailDelivery: async function () {
      this.inprogressMail = true
      this.errMessage = null
      this.updateSuccess = false

      if (this.locked) {
        this.inprogressInPerson = false
        this.errMessage = 'Account is locked. You cannot make any changes.'
        return
      }

      const val = !this.mailDelivery
      if (!val && this.inpersonDelivery === false) {
        // Show an error!
        this.errMessage = 'Oops! You need to have one delivery option available. Turn on in person delivery before removing mail delivery.'
        this.inprogressMail = false
        return
      }
      try {
        // Call the server function to generate a unique CSRF token to validate later
        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'acceptMailDelivery': val
          }, {merge: true})

        this.updateSuccess = true
      } catch (err) {
        this.errMessage = err
      }
      this.inprogressMail = false
    },
    setInPersonDelivery: async function () {
      this.inprogressInPerson = true
      this.errMessage = null
      this.updateSuccess = false

      if (this.locked) {
        this.inprogressInPerson = false
        this.errMessage = 'Account is locked. You cannot make any changes.'
        return
      }

      const val = !this.inpersonDelivery
      if (!val && this.mailDelivery === false) {
        // Show an error!
        this.errMessage = 'Oops! You need to have one delivery option available. Turn on mail delivery before removing in person delivery.'
        this.inprogressInPerson = false

        return
      }
      try {
        // Call the server function to generate a unique CSRF token to validate later
        await firebase.firestore()
          .collection('artists').doc(this.uid).collection('public').doc('settings')
          .set({
            'acceptInPersonDelivery': val
          }, {merge: true})

        this.updateSuccess = true
      } catch (err) {
        this.errMessage = err
      }
      this.inprogressInPerson = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.active {
  background-color: yellow-lighten
}
</style>
